
import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default function LifestyleSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  const images = [
    {
      src: 'https://ae-pic-a1.aliexpress-media.com/kf/S3fb43341c77c4a8d8a9c52bc3cdd55aer.jpg_220x220q75.jpg_.avif',
      caption: 'In your car',
    },
    {
      src: 'https://ae-pic-a1.aliexpress-media.com/kf/S132c3c1cd03240d89d8bec514f660b4cD.jpg?has_lang=1&ver=2_220x220q75.jpg_.avif',
      caption: 'In your pocket',
    },
    {
      src: 'https://ae-pic-a1.aliexpress-media.com/kf/S6c318865b6cf4183a7bda7555f714d45T.jpg?has_lang=1&ver=1_220x220q75.jpg_.avif',
      caption: 'On your desk',
    },
  ];

  return (
    <section ref={ref} className="py-12 sm:py-16 md:py-24 lg:py-32 bg-black">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-6 sm:mb-10 md:mb-16"
        >
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white mb-2 sm:mb-4">
            Built for Everyday Carry
          </h2>
          <p className="text-white/70 text-xs sm:text-sm md:text-base lg:text-lg max-w-2xl mx-auto">
            Pocket-ready. Bag-ready. Always clean.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={16}
            slidesPerView={1}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            loop={true}
            className="lifestyle-swiper"
          >
            {images.map((image, index) => (
              <SwiperSlide key={index}>
                <div className="relative h-[280px] sm:h-[360px] md:h-[450px] lg:h-[600px] overflow-hidden rounded-lg">
                  <img
                    src={image.src}
                    alt={image.caption}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      // Fallback handling if image fails to load
                      const target = e.currentTarget as HTMLImageElement;
                      target.src =
                        'data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300"><rect width="100%" height="100%" fill="%23333"/><text x="50%" y="50%" fill="%23fff" font-size="20" text-anchor="middle" dy=".3em">Image not available</text></svg>';
                    }}
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 sm:p-6 md:p-8">
                    <p className="text-white text-base sm:text-xl md:text-2xl lg:text-3xl font-serif">
                      {image.caption}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>

      <style>{`
        .lifestyle-swiper .swiper-pagination-bullet {
          background: white;
          opacity: 0.5;
          width: 6px;
          height: 6px;
        }
        @media (min-width: 640px) {
          .lifestyle-swiper .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
          }
        }
        @media (min-width: 768px) {
          .lifestyle-swiper .swiper-pagination-bullet {
            width: 10px;
            height: 10px;
          }
        }
        .lifestyle-swiper .swiper-pagination-bullet-active {
          opacity: 1;
        }
        .lifestyle-swiper .swiper-pagination {
          bottom: 8px !important;
        }
        @media (min-width: 640px) {
          .lifestyle-swiper .swiper-pagination {
            bottom: 12px !important;
          }
        }
      `}</style>
    </section>
  );
}
